//@ts-check
import React from 'react';
import './PulseLoader.css';

const PulseLoader = ({ size = '40px', backgroundColor = 'white', styles = {} ,...props }) => {
    return <div style={{width : size, height : size, backgroundColor : backgroundColor, ...styles }} className={'mb-pulse-spinner'} {...props} />;
};

export default PulseLoader;